/**
 * AUTO-GENERATED FILE - DO NOT EDIT MANUALLY
 *
 * Generated from the backend enums by ecomm/management/commands/generate_frontend_enums.py
 * Run: make enums-generate
 */

export const ProductType = {
  UTI_TEST: "UTI_TEST",
  VMB_TEST: "VMB_TEST",
  EXPANDED_TEST: "EXPANDED_TEST",
  PCR_ADD_ON: "PCR_ADD_ON",
  RX_TREATMENT: "RX_TREATMENT",
  OTC_TREATMENT: "OTC_TREATMENT",
  MERCHANDISE: "MERCHANDISE",
  GIFT_CARD: "GIFT_CARD",
} as const;
export type ProductType = (typeof ProductType)[keyof typeof ProductType];

export const CareVertical = {
  NONE: "NONE",
  VAGINITIS: "VAGINITIS",
  STI: "STI",
  UTI: "UTI",
  UNGATED_RX: "UNGATED_RX",
  MALE_PARTNER: "MALE_PARTNER",
} as const;
export type CareVertical = (typeof CareVertical)[keyof typeof CareVertical];

export const FulfillmentCategory = {
  TEST: "TEST",
  URINE_TEST: "URINE_TEST",
  RX: "RX",
  OTC: "OTC",
  MERCHANDISE: "MERCHANDISE",
  DIGITAL: "DIGITAL",
  UNCLASSIFIED: "UNCLASSIFIED",
} as const;
export type FulfillmentCategory = (typeof FulfillmentCategory)[keyof typeof FulfillmentCategory];

export const CareEligibilityState = {
  NEW_CUSTOMER: "new-customer",
  HEALTH_HISTORY_UPSELL: "health-history-upsell",
  CARE_INELIGIBLE: "care-ineligible",
  PRE_PURCHASE: "pre-purchase",
  PROGRAM_LAPSED: "program-lapsed",
  CONSULT_IN_PROGRESS: "consult-in-progress",
  POST_PURCHASE: "post-purchase",
  CONSULT_COMPLETED: "consult-completed",
  RETURNING_CANADIAN: "returning-canadian",
  UTI_OR_STI_CARE_ELIGIBLE: "uti-care-eligible",
} as const;
export type CareEligibilityState = (typeof CareEligibilityState)[keyof typeof CareEligibilityState];

export const ShopSectionId = {
  FOR_YOU: "for-you",
  INDIVIDUAL_RX: "individual-rx",
  ROUTINE_ESSENTIALS: "routine-essentials",
  MICROBIOME_TESTING: "microbiome-testing",
} as const;
export type ShopSectionId = (typeof ShopSectionId)[keyof typeof ShopSectionId];

export const ForYouContent = {
  CONSULT_CARD: "consult-card",
  HEALTH_HISTORY_UPSELL: "health-history-upsell",
  UTI_TREATMENT_BANNER: "uti-treatment-banner",
  STI_TREATMENT_BANNER: "sti-treatment-banner",
  TREATMENT_BUNDLE: "treatment-bundle",
  A_LA_CARE_RECOMMENDATIONS: "a-la-care-recommendations",
  PARTNER_UTI_BANNER: "partner-uti-banner",
} as const;
export type ForYouContent = (typeof ForYouContent)[keyof typeof ForYouContent];

export const CartItemType = {
  INDIVIDUAL_TREATMENT: "individual-treatment",
  BUNDLE_TREATMENT: "bundle-treatment",
  PRODUCT: "product",
} as const;
export type CartItemType = (typeof CartItemType)[keyof typeof CartItemType];

export const OrderType = {
  TEST: "TE",
  VAGINITIS_CARE: "CA",
  STI_CARE: "SC",
  UTI_CARE: "UC",
  PCR_ADD_ON: "PA",
  EXPANDED_TEST: "ET",
  URINE_TEST: "UT",
  OTHER: "OT",
  PRESCRIPTION_TREATMENT: "PR",
  A_LA_CARTE: "AL",
  DYNAMIC_BUNDLE: "BU",
  MIXED_CARE: "MC",
  UNGATED_RX: "UX",
  MALE_PARTNER: "MP",
  GIFT_CARD: "GC",
} as const;
export type OrderType = (typeof OrderType)[keyof typeof OrderType];

export const LinePurchaseType = {
  INDIVIDUAL: "individual",
  BUNDLE: "bundle",
} as const;
export type LinePurchaseType = (typeof LinePurchaseType)[keyof typeof LinePurchaseType];

export const ConsultType = {
  VAGINITIS: "vaginitis",
  STI: "sti",
  UNGATED_RX: "ungated-rx",
  MALE_PARTNER: "male-partner",
  UTI: "uti",
} as const;
export type ConsultType = (typeof ConsultType)[keyof typeof ConsultType];

export const ConsultPurchaseType = {
  V0_BUNDLE: "v0-bundle",
  UNGATED_RX: "ungated-rx",
  A_LA_CARTE: "a-la-care",
  DYNAMIC_BUNDLE: "dynamic-bundle",
  BUNDLE_A_LA_CARE: "bundle-and-a-la-care",
  MALE_PARTNER: "male-partner",
} as const;
export type ConsultPurchaseType = (typeof ConsultPurchaseType)[keyof typeof ConsultPurchaseType];

export const CartPurchaseType = {
  V0_BUNDLE: "v0-bundle",
  UNGATED_RX: "ungated-rx",
  A_LA_CARTE: "a-la-care",
  DYNAMIC_BUNDLE: "dynamic-bundle",
  BUNDLE_A_LA_CARE: "bundle-and-a-la-care",
  MALE_PARTNER: "male-partner",
  OTC: "otc",
} as const;
export type CartPurchaseType = (typeof CartPurchaseType)[keyof typeof CartPurchaseType];
